import React from 'react';
import Item from './Item';
import Logger from '../../../toolkit/logger/Logger';
import rolesMap from '../../../utils/roles-map';
import { getCurrentUser } from '../../../utils/auth';

import './Sidebar.scss';

export interface SidebarProps {
  brand?: string;
}

export interface SidebarState {
  isOpen: boolean;
  username: string;
  userAccess: string;
}

class Sidebar extends React.Component<SidebarProps, SidebarState> {

  public static Item: typeof Item;

  private static instance: Sidebar = null;

  public state = {
    isOpen: false,
    username: 'در حال دریافت',
    userAccess: 'کاربر'
  }

  public static onToggleButtonClick = () => {
    const isOpen = Sidebar.instance.state.isOpen;
    Logger.log('Sidebar::ToggleClick => ' + !isOpen);
    Sidebar.instance.setState({ isOpen: !isOpen });
  }

  public static openSidebar = () => {
    Sidebar.instance.setState({ isOpen: true });
  }

  public static closeSidebar = () => {
    Sidebar.instance.setState({ isOpen: false });
  }

  public constructor(props: SidebarProps) {
    super(props);
    Sidebar.instance = this;
  }

  render() {
    return (
      <aside className={'sidebar-component' + (this.state.isOpen ? ' state-open' : '')}>
        <div className="brand-container">
          <i className="fab fa-cloudversify"></i>
          {/* <span><span style={{color: '#8659d4'}}>دارستان</span> صنعت</span> */}
          <span>{this.props.brand ?? 'Sidebar'}</span>
        </div>
        <div className="sidebar-content">
          <div className="sidebar-user-info">
            <i className="fal fa-user-tie fa-3x"></i>
            <div className="inner">
              <div>{this.state.username}</div>
              <div>{rolesMap(this.state.userAccess)}</div>
            </div>
          </div>
          <ul className="sidebar-list">
            {this.props.children}
          </ul>
        </div>
      </aside>
    );
  }

  componentDidMount = async () => {
    const user = getCurrentUser();
    if (user) {
      const { name, access } = user;
      this.setState({ username: name, userAccess: access });
    }
  }

}

export default Sidebar;
